import { useEffect, useState } from "react";

// Reference anchors — Pixel Dave's §13 regression numbers.
// Never edit without verifying the engine still matches these to the cent.
// 2026-02-24 · per_member_per_month recomputed as year1_contribution ÷ members ÷ 12
// (was previously annual_contribution ÷ ÷ — pre-adjustment). Matches Dave's
// proof screenshot: Lakes Y1 Budget $64,600 ÷ 20 ÷ 12 = $269.17.
export const REFERENCE_ANCHORS = {
  "00000000-0000-4000-8000-000000000010": {
    full_funding: 418966,
    target_funding: 167586,
    annual_contribution: 12300,
    year1_contribution: 8600,
    per_member_per_month: 71.67,
    ending_balance: 292631,
  },
  "00000000-0000-4000-8000-000000000020": {
    full_funding: 5619101,
    target_funding: 2247640,
    annual_contribution: 92300,
    year1_contribution: 64600,
    per_member_per_month: 269.17,
    ending_balance: 2081785,
  },
};

// Dev-mode store — module-level so ALL useDevMode() consumers stay in sync.
// (Previously each component held its own useState → clicking "exit" only
// updated the caller.)  Backed by sessionStorage so nav clicks + reloads
// preserve the flag.
const STORAGE_KEY = "ureserve.devMode";
const listeners = new Set();

function readInitial() {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("dev") === "1";
    const fromStore = window.sessionStorage.getItem(STORAGE_KEY) === "1";
    if (fromUrl) {
      try { window.sessionStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    }
    return fromUrl || fromStore;
  } catch {
    return false;
  }
}

let devModeState = typeof window !== "undefined" ? readInitial() : false;

function setDevMode(next) {
  if (next === devModeState) return;
  devModeState = next;
  for (const l of listeners) {
    try { l(devModeState); } catch { /* ignore */ }
  }
}

export function useDevMode() {
  const [enabled, setEnabled] = useState(devModeState);

  useEffect(() => {
    listeners.add(setEnabled);
    // Sync if module state changed between initial render and effect commit.
    if (enabled !== devModeState) setEnabled(devModeState);
    return () => { listeners.delete(setEnabled); };
  }, []);

  const disable = () => {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete("dev");
      window.history.replaceState({}, "", url.toString());
    } catch { /* ignore */ }
    setDevMode(false);
  };

  return [enabled, disable];
}
